'use strict';

const _ = require('underscore');
const Moment = require('moment');
const Backbone = require('backbone');

module.exports = class TaskInCommentCollection extends Backbone.Collection {
    constructor(models, options) {
        super(models, options);

        this._comment = options.comment;
        this._repository = options.repository;

        this.listenTo(this._repository, 'add', task => {
            if(task.getCommentKey() && task.getCommentKey().isEqual(this._comment.key)) {
                this.add(task);
            }
        });
    }

    // updatedAt でソートした後、state でソートする
    model2number(model) {
        const time = Moment(model.getUpdatedAt()).unix();

        // state が done の場合は unix time に比べて十分大きい値を足す
        if(model.isDone()) {
            return - time + 1000000000;
        }

        return - time;
    }

    fetchTasksByIDs() {
        const taskIds = this._comment.getTaskIds();

        return Promise.all(
            _.map(taskIds, id => this._repository.fetchTaskByID(id))
        ).then(tasks => {
            // tasks の中に null 要素が含まれる可能性があるので _.compact で取り除く
            this.add(_.compact(tasks), {merge: true});

            return this;
        });
    }
};



// WEBPACK FOOTER //
// ./communication/domain/collection/task-in-comment.js